<template>
  <div class="edit-image-group-layout">
    <ul class="editor-design">
      <li>
        レイアウト
      </li>
      <!-- レイアウト選択 -->
      <li>
        <ul class="flex-box">
          <li v-for="layout in layouts" :key="layout.value">
            <button
              type="btn"
              class="image-group-layout"
              :class="[layout.value, {'active': imageGroupLayout === layout.value}]"
              @click="changeLayout(layout.value)"
            >
              <div :class="layout.class1"/>
              <div :class="layout.class2"/>
            </button>
          </li>
        </ul>
      </li>
      <li class="flex-box">
        <div class="edit-style-select-box">
          <span class="common-label">カラム数</span>
          <div class="common-select">
            <select
              :target="'column'"
              :value="partsCount"
              @input="updateNumberOfColumns($event.target.value)"
            >
              <option v-for="option in options" :key="option.value" :value="option.value">
                {{ option.text }}
              </option>
            </select>
          </div>
        </div>
        <div>
          <!-- モバイル表示 -->
          <li>
            <select-box
              :target="'flg-side'"
              :value="flgSide"
              :disabled="isflgSideDisabled"
              @updateStyles="updatePartsContainer($event)"
            />
          </li>
        </div>
        <div>
          <!-- モバイル表示 画面幅フィット -->
          <setting-check-box
            :target="'flg_image_content_mobile_full_width'"
            :value="flgImageContentMobileFullWidth"
            @update="updatePartsContainer($event)"
            />
        </div>
      </li>
      <!-- 上下余白 -->
      <li class="flex-box">
        <slider
          :prop="'padding-top'"
          :value="partsContainerStyles['padding-top']"
          @updateStyles="updatePartsContainerStyles($event)"
        />
      </li>
      <!-- 左右余白 -->
      <li class="flex-box">
        <slider
          :prop="'padding-right'"
          :value="partsContainerStyles['padding-right']"
          @updateStyles="updatePartsContainerStyles($event)"
        />
      </li>
      <!-- 間隔調整 -->
      <li class="flex-box">
        <slider
          :prop="'spacer-width'"
          :value="spacerWidth"
          @updateStyles="updateSpacerSize($event)"
        />
      </li>
    </ul>
  </div>
</template>

<script>
import EditSettingSelectBase from '@/components/Content/Palette/CommonLayouts/Base/EditSettingSelectBase'
import SelectBox from '@/components/Content/Palette/CommonLayouts/EditStyleSelectBox'
import Slider from '@/components/Content/Palette/CommonLayouts/EditStyleSlider'
import SettingCheckBox from '@/components/Content/Palette/CommonLayouts/EditSettingCheckBox'

export default {
  props: [
    'sectionId',
    'partsContainerId',
    'imageCount',
    'partsContainerStyles',
    'spacerParts',
    'flgSide',
    'flgImageContentMobileFullWidth',
  ],
  mixins: [
    EditSettingSelectBase,
  ],
  components: {
    SelectBox,
    Slider,
    SettingCheckBox,
  },
  data () {
    return {
      layouts: []
    }
  },
  computed: {
    imageGroupLayout () {
      const partsContainer = this.$store.getters.findPartsContainer(this.sectionId, this.partsContainerId)
      if (!partsContainer) return null
      let imageGroupLayout
      if (partsContainer.layout_type === 'horizontal') {
        // 横並び
        imageGroupLayout = 'image2-horizontal'
      } else if (partsContainer.layout_type === 'vertical') {
        // 縦並び
        imageGroupLayout = 'image2-vertical'
      }
      return imageGroupLayout
    },
    spacerWidth () {
      if (!this.spacerParts) return null
      // スペーサーがない場合、スペーサーの大きさは0pxとする
      return this.spacerParts.length === 0 ? '0px' : this.spacerParts[0].attrs['width']
    },
    isflgSideDisabled () {
      return !this.imageGroupLayout || this.imageGroupLayout !== 'image2-horizontal'
    },
    partsCount () {
      return this.$store.getters.getPartsCountOfPartsContainer(this.sectionId, this.partsContainerId)
    },
  },
  methods: {
    initComponent () {
      this.layouts = [
        { value: 'image2-horizontal', class1: 'image2-horizontal-left', class2: 'image2-horizontal-right' },
        { value: 'image2-vertical', class1: 'image2-vertical-top', class2: 'image2-vertical-bottom' },
      ]
    },
    changeLayout (event) {
      if (this.imageGroupLayout === event) return
      this.$store.dispatch('updateImageGroupLayout', {
        sectionId: this.sectionId,
        partsContainerId: this.partsContainerId,
        newLayout: event,
      })
    },
    updatePartsContainer (values) {
      this.$store.commit('updatePartsContainer', {
        sectionId: this.sectionId,
        partsContainerId: this.partsContainerId,
        values,
      })
    },
    updatePartsContainerStyles (styles) {
      this.$store.dispatch('updateImagePartsContainerStyles', {
        sectionId: this.sectionId,
        partsContainerId: this.partsContainerId,
        styles,
      })
    },
    updateSpacerSize (value) {
      this.$store.dispatch('updateImageGroupSpacerSize', {
        sectionId: this.sectionId,
        partsContainerId: this.partsContainerId,
        value,
      })
    },
    // カラム数の更新
    updateNumberOfColumns (value) {
      this.$store.dispatch('updateImageGroupColumnCount', {
        sectionId: this.sectionId,
        partsContainerId: this.partsContainerId,
        value,
      })
    },
  },
  beforeMount () {
    this.initComponent()
    this.options = this.ImageGroupColumnOptions
  }
}
</script>

<style lang="scss" scoped>
// レイアウト選択ボタンの外枠
.image-group-layout {
  width: 80px;
  height: 80px;
  margin-right: 8px;
  transition-duration: 0.5s;
  opacity: 0.2;
  div {
    border: 2px solid #333333;
    box-sizing: border-box;
  }
}
.edit-image-group-layout {
  .flex-box {
    margin-left: 20px;
  }
}

// 選択済のレイアウト：暗くする
.active {
  transition-duration: 0.5s;
  opacity: 0.9;
}

// 画像2枚：横並び
.image2-horizontal {
  display: flex;
  div {
    width: 40px;
    height: 80px;
    flex-shrink: 0;
  }
  .image2-horizontal-right {
    border-left: none;
  }
}

// 画像2枚：縦並び
.image2-vertical {
  div {
    width: 80px;
    height: 40px;
    flex-shrink: 0;
  }
  .image2-vertical-bottom {
    border-top: none;
  }
}
.edit-image-group-layout {
  .flex-box:last-of-type {
    margin-bottom: 0;
    padding-bottom: 10px;
  }
}
</style>
